define('home/collections/FollowingForumCollection',[
    'underscore',
    'home/utils/backboneUtils',

    'home/collections/ForumCollection',

    'core/api',
], function (
    _,
    BackboneUtils,

    ForumCollection,

    api
) {
    'use strict';

    var FollowingForumCollection = ForumCollection.extend({
        url: api.getURL('users/listFollowingForums'),

        initialize: function () {
            this.on('add', this.completeModel);
        },

        completeModel: function (model) {
            if (!model.get('name'))
                model.fetch();
        },

        fetch: function (options) {
            options = options || {};

            // Load the max possible number of forums at a time
            // to prevent pagination issues for now, as almost
            // no users follow more than 100 forums.
            options.data = _.defaults({
                limit: 100,
            }, options.data);

            return BackboneUtils.memoizedFetch.call(this, options);
        },

        parse: function (response) {
            if (Boolean(response) && Boolean(response.response) && _.isArray(response.response)) {
                response = _.defaults({ response: _.filter(response.response, function (channel) {
                    return channel.id.indexOf('channel-') === -1 || channel.id === 'channel-discussdisqus';
                }) }, response);
            }

            response = ForumCollection.prototype.parse.call(this, response);

            return response;
        },
    });

    return FollowingForumCollection;
});

